"use client";
import Link from "next/link";
import { ChevronLeft } from "lucide-react";
import SwiperComponent from "@/components/ui/swiper-component";
import ProductCard from "@/components/ProductCard";
import Title from "../Title";
import DeviceOnly from "@/components/DeviceOnly";

export default function HomeProductsSlider({ fields, collection_data, limit = 10, isArticleContent = false }) {
    const gutter_class = isArticleContent ? "" : "px-4 md:px-10";
    const mobile_swiper_class = isArticleContent ? undefined : "px-4! md:px-10!";
    const desktop_breakpoints = isArticleContent
        ? {
            1024: { slidesPerView: 3.1, spaceBetween: 12 },
            1280: { slidesPerView: 3.8, spaceBetween: 12 },
        }
        : {
            380: { slidesPerView: 2.1, spaceBetween: 8 },
            500: { slidesPerView: 2.8, spaceBetween: 8 },
            640: { slidesPerView: 3, spaceBetween: 8 },
            767: { slidesPerView: 3.5, spaceBetween: 12 },
            920: { slidesPerView: 4, spaceBetween: 12 },
            1024: { slidesPerView: 4.5, spaceBetween: 16 },
            1280: { slidesPerView: 5.5, spaceBetween: 16 },
        };

    // کارت‌ها همراه ویجت از کوئری صفحه (getPrefixUrlDetails) می‌آیند؛ fetch کلاینتی نداریم
    const products = collection_data?.products || [];

    return (
        <>
            <DeviceOnly on="mobile">
            <div className="block lg:hidden w-full mx-auto">

                {/* Header */}
                <div className={`flex items-center justify-between pb-4 ${gutter_class}`}>
                    <Title type={fields?.title?.type} className="flex items-center text-jmt-main font-bold text-base lg:text-lg">
                        <span>{fields?.title?.title || ""}</span>
                    </Title>
                    {fields?.link?.url ?
                        <Link href={fields?.link?.url} className="flex items-center text-xs lg:text-sm font-bold text-jmt-neutral-800 hover:text-black transition gap-1">
                            {fields?.["text-link"]}
                            <ChevronLeft className="w-4.5 h-4.5 lg:w-5 lg:h-5" />
                        </Link> : ""}
                </div>

                <SwiperComponent
                    slides_shadow_space
                    slides={products?.length > 0 ? products.slice(0, limit).map((product, index) => (
                        <div
                            key={`product--key${product.id}`}
                            className="h-full bg-white border border-jmt-neutral-200 hover-shadow-full-light rounded-md overflow-hidden">
                            <ProductCard product={product} index={index} />
                        </div>
                    )) : []}
                    breakpoints={{
                        380: { slidesPerView: 2.1, spaceBetween: 8 },
                        500: { slidesPerView: 2.8, spaceBetween: 8 },
                        640: { slidesPerView: 3, spaceBetween: 8 },
                        767: { slidesPerView: 3.5, spaceBetween: 12 },
                        920: { slidesPerView: 4, spaceBetween: 12 },
                        1024: { slidesPerView: 4.5, spaceBetween: 16 },
                        1280: { slidesPerView: 5.5, spaceBetween: 16 },
                    }}
                    slidesPerView={1.5}
                    spaceBetween={8}
                    navigation={true}
                    hideNavOnMobile={true}
                    navPosition="sides"
                    swiper_className={mobile_swiper_class}
                    loop={false}
                    pagination={false}
                    grabCursor={true}
                />
            </div>
            </DeviceOnly>

            <DeviceOnly on="desktop">
            <div className="hidden lg:block w-full">
                <div className={isArticleContent ? "" : "container"}>

                    {/* Header */}
                    <div className="flex items-center justify-between pb-4 ">
                        <Title type={fields?.title?.type} className="flex items-center text-jmt-main font-bold text-base lg:text-lg">
                            <span>{fields?.title?.title || ""}</span>
                        </Title>
                        {fields?.link?.url ?
                            <Link href={fields?.link?.url} className="flex items-center text-xs lg:text-sm font-bold text-jmt-neutral-800 hover:text-black transition gap-1">
                                {fields?.["text-link"]}
                                <ChevronLeft className="w-4.5 h-4.5 lg:w-5 lg:h-5" />
                            </Link> : ""}
                    </div>

                    <SwiperComponent
                        slides_shadow_space
                        slides={products?.length > 0 ? products.slice(0, limit).map((product, index) => (
                            <div
                                key={`product--key${product.id}`}
                                className="h-full bg-white border border-jmt-neutral-200  hover-shadow-full-light rounded-md overflow-hidden">
                                <ProductCard
                                    product={product} index={index}
                                />
                            </div>
                        )) : []}
                        breakpoints={desktop_breakpoints}
                        slidesPerView={1.5}
                        spaceBetween={8}
                        navigation={true}
                        hideNavOnMobile={true}
                        navPosition="sides"
                        loop={false}
                        pagination={false}
                        grabCursor={true}
                    />

                </div>
            </div>
            </DeviceOnly>
        </>


    );

}
